import { render, staticRenderFns } from "./timesheet-comment.vue?vue&type=template&id=25227a7c&scoped=true&"
import script from "./timesheet-comment.vue?vue&type=script&lang=ts&"
export * from "./timesheet-comment.vue?vue&type=script&lang=ts&"
import style0 from "./timesheet-comment.vue?vue&type=style&index=0&id=25227a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25227a7c",
  null
  
)

export default component.exports